(function () {
  var LOCK = 'pim-lock';

  function focusable(panel) {
    return Array.prototype.slice
      .call(
        panel.querySelectorAll(
          'a[href],button:not([disabled]),textarea:not([disabled]),input:not([type="hidden"]):not([disabled]):not([readonly]),select:not([disabled]),[tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (n) {
        return n.offsetWidth > 0 || n.offsetHeight > 0 || n === document.activeElement;
      });
  }

  var lockCount = 0;
  function lockScroll() {
    lockCount++;
    if (lockCount === 1) document.documentElement.classList.add(LOCK);
  }
  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (!lockCount) document.documentElement.classList.remove(LOCK);
  }

  function portalToBody(root) {
    if (!root || root.getAttribute('data-pim-portaled') === '1') return;
    /* Kai protėvis turi transform/filter, „fixed“ skaičiuojamas nuo jo — perdanga neuždengia puslapio.
       Kaip Dawn modal-dialog — keliame į body. */
    document.body.appendChild(root);
    root.setAttribute('data-pim-portaled', '1');
  }

  function bindCloseUi(root, panel) {
    var closeBtn = root.querySelector('.pim__close');

    var stopClose = function (e) {
      e.preventDefault();
      e.stopPropagation();
      close(root);
    };

    /* Paspaudimas ant tamsaus fono (viskas, kas ne panelės viduje) */
    var outsideClick = function (e) {
      if (panel.contains(e.target)) return;
      close(root);
    };

    if (closeBtn) closeBtn.addEventListener('click', stopClose);
    root.addEventListener('click', outsideClick);

    root._pimStopClose = stopClose;
    root._pimOutsideClick = outsideClick;
    root._pimCloseEl = closeBtn;
  }

  function unbindCloseUi(root) {
    if (root._pimCloseEl && root._pimStopClose) {
      root._pimCloseEl.removeEventListener('click', root._pimStopClose);
    }
    if (root._pimOutsideClick) {
      root.removeEventListener('click', root._pimOutsideClick);
    }
    root._pimStopClose = root._pimOutsideClick = root._pimCloseEl = null;
  }

  function open(root, trigger) {
    if (!root || root.hasAttribute('data-pim-active')) return false;
    var panel = root.querySelector('[data-pim-panel]');
    if (!panel) return false;

    portalToBody(root);

    root.setAttribute('data-pim-active', '');
    root.removeAttribute('hidden');
    lockScroll();

    bindCloseUi(root, panel);

    var onTab = function (e) {
      if (e.key !== 'Tab') return;
      var list = focusable(panel);
      if (list.length < 2) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    var onEsc = function (e) {
      if (e.key === 'Escape') close(root);
    };

    root._pimPrevFocus = trigger && trigger.focus ? trigger : null;
    root._pimOnTab = onTab;
    root._pimOnEsc = onEsc;
    panel.addEventListener('keydown', onTab);
    document.addEventListener('keydown', onEsc);

    var focusTarget = root.querySelector('[data-pim-initial-focus]') || focusable(panel)[0];
    if (focusTarget) focusTarget.focus();

    return true;
  }

  function close(root) {
    if (!root || !root.hasAttribute('data-pim-active')) return;
    var panel = root.querySelector('[data-pim-panel]');
    root.removeAttribute('data-pim-active');
    root.setAttribute('hidden', '');
    unlockScroll();

    unbindCloseUi(root);

    if (panel && root._pimOnTab) panel.removeEventListener('keydown', root._pimOnTab);
    if (root._pimOnEsc) document.removeEventListener('keydown', root._pimOnEsc);
    root._pimOnTab = root._pimOnEsc = null;

    if (root._pimPrevFocus) root._pimPrevFocus.focus();
    root._pimPrevFocus = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pim-trigger]');
    if (!opener) return;
    e.preventDefault();
    var id = opener.getAttribute('data-pim-trigger');
    var root = document.getElementById('pim-root-' + id);
    open(root, opener);
  });

  document.addEventListener('DOMContentLoaded', function () {
    try {
      var params = new URLSearchParams(location.search);
      var bid = params.get('open_product_inquiry');
      if (!bid) return;
      var root = document.getElementById('pim-root-' + bid);
      if (!open(root, null)) return;
      params.delete('open_product_inquiry');
      var qs = params.toString();
      history.replaceState({}, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    } catch (err) {}
  });
})();
